import { Brand } from "./Brand";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="content-width footer-inner">
        <div className="footer-brand-block">
          <Brand footer />
          <p>
            高度なスキルを持つ若者が、互いに競い、学び、社会とつながるコミュニティ。
          </p>
          <a
            className="footer-social-link"
            href="https://x.com/AIYSS_PR"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="AIYSS公式X（@AIYSS_PR）を開く"
          >
            <span aria-hidden="true">𝕏</span>
            <span>X / @AIYSS_PR</span>
          </a>
        </div>
        <nav className="footer-links" aria-label="フッターリンク">
          <div className="footer-link-group">
            <h2>AIYSSについて</h2>
            <a href="/">TOP</a>
            <a href="/activities/">活動内容</a>
            <a href="/members/">メンバー</a>
            <a href="/articles/">ARTICLES / 活動報告記事</a>
            <a href="/contact/">お問い合わせ</a>
          </div>
          <div className="footer-link-group">
            <h2>サービス</h2>
            <a href="/job-quest/">AIYSS Job Quest</a>
            <a href="/job-quest/board/">Quest Board</a>
            <a href="/league/">年間リーグ</a>
            <a href="/league/register/">リーグに登録する</a>
          </div>
          <div className="footer-link-group">
            <h2>企業の方へ</h2>
            <a href="/sponsors/">スポンサー</a>
            <a href="/contact/?type=sponsor#contact">
              スポンサー協賛についてお問い合わせ
            </a>
          </div>
        </nav>
        <div className="footer-meta">
          <span>© 2026 AIYSS</span>
          <a href="#top">TOP ↑</a>
        </div>
      </div>
    </footer>
  );
}
